import { FC, ReactNode } from 'react';

import { Card, CardProps, Flex, Typography } from 'antd';

const { Title, Text } = Typography;

interface IProfileSectionProps extends CardProps {
	title: ReactNode;
	subtitle?: ReactNode;
}

export const ProfileSection: FC<IProfileSectionProps> = ({ className, title, subtitle, children, ...props }) => {
	return (
		<Card {...props} className={className} styles={{ body: { padding: 20 } }}>
			<Flex vertical gap={16}>
				<Flex vertical gap={8}>
					<Title level={5} style={{ margin: 0 }}>
						{title}
					</Title>
					{subtitle && <Text type="secondary">{subtitle}</Text>}
				</Flex>
				<div>{children}</div>
			</Flex>
		</Card>
	);
};
